import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { getAllCCDs, getCCDsByPatient, createCCD } from '../../services/careCoordinationService';

export default function PatientSummaryTab({ patientId, patients }) {
  const [ccds, setCCDs] = useState([]);

  useEffect(() => {
    if (patientId) {
      getCCDsByPatient(patientId).then(setCCDs);
    } else {
      getAllCCDs().then(setCCDs);
    }
  }, [patientId]);

  const handleGenerate = async () => {
    if (!patientId) {
      alert('Please select a patient to generate a CCD.');
      return;
    }
    const newCCD = {
      patientId,
      date: new Date().toISOString().slice(0, 10),
      type: 'CCD',
      format: 'XML',
      fileName: `ccd-${new Date().toISOString().slice(0, 10)}.xml`,
      fileUrl: '',
    };
    await createCCD(newCCD);
    getCCDsByPatient(patientId).then(setCCDs);
  };

  const handleDownload = (ccd) => {
    if (ccd.fileUrl) {
      window.open(ccd.fileUrl, '_blank');
    } else {
      alert('No file available');
    }
  };

  // Helper to get patient name by id
  const getPatientName = (id) => {
    if (!id || !patients || patients.length === 0) return 'Unknown Patient';
    
    // Try different ways to find the patient
    let p = patients.find(p => p.patientId === id);
    if (!p) p = patients.find(p => p.id === id);
    if (!p) p = patients.find(p => p._id === id);
    
    if (p) {
      // Handle different patient name structures
      if (p.firstName && p.lastName) {
        return `${p.firstName} ${p.lastName}`;
      } else if (p.name) {
        return p.name;
      } else if (p.firstName) {
        return p.firstName;
      } else if (p.lastName) {
        return p.lastName;
      }
    }
    
    // If we can't find the patient, show a more user-friendly message
    return `Patient ${id.substring(0, 8)}...`;
  };

  return (
    <Box>
      <Box display="flex" alignItems="center" mb={2}>
        <Button variant="contained" onClick={handleGenerate} sx={{ mr: 2 }}>
          Generate CCD
        </Button>
        <Typography variant="body2" color="text.secondary">
          Generate and export Continuity of Care Documents (CCD/C-CDA)
        </Typography>
      </Box>
      <Typography variant="subtitle1" gutterBottom>
        Previously Generated CCDs
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Patient</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Format</TableCell>
              <TableCell>File</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ccds.map((ccd) => {
              console.log('PatientSummaryTab: Processing CCD:', {
                id: ccd.id,
                patientId: ccd.patientId,
                embeddedName: ccd.content?.demographics?.name,
                fallbackName: getPatientName(ccd.patientId)
              });
              
              return (
                <TableRow key={ccd.id}>
                  <TableCell>
                    {ccd.content?.demographics?.name || getPatientName(ccd.patientId)}
                  </TableCell>
                  <TableCell>
                    {ccd.createdAt ? new Date(ccd.createdAt._seconds * 1000).toLocaleDateString() : 'N/A'}
                  </TableCell>
                  <TableCell>{ccd.type}</TableCell>
                  <TableCell>{ccd.format}</TableCell>
                  <TableCell>{ccd.fileName}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleDownload(ccd)}>
                      <DownloadIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
} 